import { gql } from 'graphql-request';
import { LocationFragment } from '../fragments/fragments';

export const GetInvestorOffering = gql`
  ${LocationFragment}
  query getInvestorOffering {
    findAllPublicOffers {
      operatorId
      id
      description {
        en
        heb
      }
      name
      location {
        ...LocationFragment
      }
      category
      customCategory
      strategy
      offerStartDate
      kpis {
        key
        value
      }
    }
  }
`;
